import { render, staticRenderFns } from "./EditAwrStatus.vue?vue&type=template&id=32533701&"
import script from "./EditAwrStatus.vue?vue&type=script&lang=js&"
export * from "./EditAwrStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports